export const ConnectStripe = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_24094_16105)">
      <rect width="20" height="20" rx="6" fill="#635BFF" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#00009B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.21955 7.775C9.21955 7.305 9.60455 7.12 10.2446 7.12C11.1646 7.12 12.3246 7.4 13.2446 7.895V5.055C12.2396 4.655 11.2496 4.5 10.2496 4.5C7.79455 4.5 6.16455 5.78 6.16455 7.92C6.16455 11.255 10.7596 10.725 10.7596 12.165C10.7596 12.72 10.2746 12.9 9.59955 12.9C8.59455 12.9 7.31455 12.49 6.29955 11.935V14.81C7.42455 15.295 8.55955 15.5 9.59955 15.5C12.1146 15.5 13.8446 14.255 13.8446 12.09C13.8246 8.49 9.21955 9.13 9.21955 7.775V7.775Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_24094_16105"
        x="0"
        y="0"
        width="20"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_24094_16105" />
      </filter>
    </defs>
  </svg>
)

export default ConnectStripe
